// Single source of truth for the public origin. Both the React app and the
// Node build scripts read from here, so changing the domain touches one file.
module.exports = {
  SITE_URL: 'https://masha-normalno.ru',
};
